export const AIS3_SLICE = 'AIS3_SLICE';
